import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
// ui
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
// style
import { createStyles, makeStyles } from "@material-ui/styles";
// components
import { useNavigate } from "react-router";
import { useIntl } from "react-intl";
import LinearProgress from "@mui/material/LinearProgress";
import TemplateAuth from "../components/TemplateAuth";
import ButtonBasic from "../../common/components/button/ButtonBasic";
import fireAuth from "../../api/firebase/auth/utils";
import { StoreContext } from "../../store/StoreProvider";
import useLocaleRoute from "../../common/hooks/useLocaleRoute";
import { ROUTE_PATH } from "../../config/CONSTANTS";
import Act from "../../store/actions";
import urls from "../../api/project/ApiUrls";

// utils

//
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

//
const LogoutPage = () => {
  //
  const navigate = useNavigate();
  // 語系
  const intl = useIntl();
  // style
  const classes = useStyles();
  // props

  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user: globalUser } = state;
  const { displayName, locale } = globalUser;
  const inLogoutProcess = true; // 正在登出中
  const isLoggedIn = fireAuth.isLoggedIn(globalUser);
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );

  const handleLogout = () => {
    fireAuth.getAuth().signOut();
    setTimeout(() => {
      // 回到登入頁面
      navigate(handleLocaleRoute(ROUTE_PATH.Home));
      // 設定訊息
      dispatch({
        type: Act.COMMON_SET_MESSAGE,
        payload: {
          open: true,
          content: intl.formatMessage({
            id: "logout.success.message",
            defaultMessage: "你已成功登出",
          }),
        },
      });
    }, 2000);
  };

  // 使用者進到這個頁面後,直接登出
  useEffect(() => {
    handleLogout();
  }, []);

  return (
    <TemplateAuth>
      <Grid container justifyContent="center">
        <Grid item>
          <Box textAlign="center" pt={5} mt={5}>
            {inLogoutProcess && (
              <Box mb={3} minWidth="300px">
                <Typography variant="h6">
                  {intl.formatMessage({
                    id: "logout.inprogress",
                    defaultMessage: "登出中",
                  })}
                </Typography>
                <LinearProgress />
              </Box>
            )}
            <Box mb={3}>
              <Typography variant="h6">
                {!inLogoutProcess &&
                  displayName &&
                  intl.formatMessage(
                    {
                      id: "login.status",
                      defaultMessage: "{name}, 你已登入",
                    },
                    {
                      name: displayName,
                    }
                  )}
              </Typography>
            </Box>
            {!inLogoutProcess && displayName && (
              <ButtonBasic
                text={intl.formatMessage({
                  id: "logout",
                  defaultMessage: "登出",
                })}
                onClick={handleLogout}
              />
            )}
          </Box>
        </Grid>
      </Grid>
    </TemplateAuth>
  );
};

LogoutPage.propTypes = {};

LogoutPage.defaultProps = {};

export default LogoutPage;
